import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CallDetailsParticipant } from 'features/call/call-details/components';
import { useCallDetailsCaller } from 'features/call/call-details/hooks';
import { Separator } from 'features/call/call-details/styles';
import { useEmergencyCallDetailsCallee } from 'features/emergency/hooks';

export const EmergencyCallDetailsCalleeConnected: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'callDetails' });
  const { caller } = useCallDetailsCaller();
  const { callee } = useEmergencyCallDetailsCallee();

  return (
    <>
      <CallDetailsParticipant {...caller} />
      {callee && (
        <>
          <Separator />
          <CallDetailsParticipant {...callee} title={t('callTo')} />
        </>
      )}
    </>
  );
};
